import React, { useState } from "react";
import styles from "./SupervisorProductJourney.module.css";
import HeadingComponent from "../../../../../../components/HeadingComponent/HeadingComponent";
import { TextComponent } from "../../../../../../components";
import TopTabComponent from "../../../../../../components/TopTabComponent/TopTabComponent";
import Mixing from "./Mixing/Mixing";
import { AiFillBehanceCircle } from "react-icons/ai";
import { ReactComponent as TabIcon } from "../../../../../../assets/images/tabIcon.svg";
import MakeUp from "./MakeUp/MakeUp";
import Proofing from "./Proofing/Proofing";
import Chilling from "./Chilling/Chilling";
import Oven from "./Oven/Oven";
import Packaging from "./Packaging/Packaging";
import Assembly from "./Assembly/Assembly";
import HeaderComponent from "../../../../../../components/HeaderComponent/HeaderComponent";

const SupervisorProductJourney = () => {
  const options = [
    { id: 1, name: "Mixing", Icon: <TabIcon width={16} height={16} /> },
     { id: 2, name: "Oven", Icon: <TabIcon width={16} height={16} /> },
  ];
  const [focusedTab, setFocusedTab] = useState(options[0]);
  return (
    <div className={styles.mainCont}>
      <div className={styles.HeadingDiv}>
        <HeaderComponent
          showBackIcon={true}
          heading={"Product Journey: Bread Dough"}
          headingStyle={styles.Heading}
        />
      </div>

      <div>
      <TopTabComponent
        options={options}
        focused={focusedTab}
        setFocused={setFocusedTab}
        TopTabListStyle={styles.TopTabListStyle1}
      />
</div>
      {focusedTab?.name === options[0]?.name && <Mixing />}
      {focusedTab?.name === options[1]?.name && <Oven />}
    </div>
  );
};

export default SupervisorProductJourney;
